import { ActionSheetButton, ActionSheetController } from 'ionic-angular';
import { Injectable } from '@angular/core';

import {
  EnvironmentProvider,
  ServerEnvironment,
} from './../environment/environment';
import { LoadingAlertProvider } from './../loading-alert/loading-alert';
import { SessionProvider } from './../session/session';
import { UserProvider } from './../user/user';

export enum AppMode {
  Consumer = 'consumer',
  Filler = 'filler',
  Provider = 'provider',
}

@Injectable()
export class AppModeProvider {
  static readonly APP_MODE_KEY = 'APP_MODE';

  constructor(
    public session: SessionProvider,
    private userService: UserProvider,
    private environment: EnvironmentProvider,
    private loadingAlertCtrl: LoadingAlertProvider,
    private actionSheetCtrl: ActionSheetController
  ) {}

  showModeSwitchingActionSheet() {
    const user = this.userService.currentUser$.value;
    const buttons: ActionSheetButton[] = [];

    if (user && user.admin) {
      buttons.push({
        text: 'Switch Environments',
        handler: () => this.showEnvironmentActionSheet(),
      });
    }

    buttons.push({
      text: 'Log Out',
      handler: () => {
        this.logout();
      },
    });

    buttons.push({
      text: 'Cancel',
      role: 'cancel',
    });

    this.actionSheetCtrl.create({ buttons }).present();
  }

  showEnvironmentActionSheet() {
    const currentEnv = this.environment.serverEnvironment$.value;
    const buttons: ActionSheetButton[] = [];
    const title = `The current environment is ${currentEnv}`;

    for (let key in ServerEnvironment) {
      const env = ServerEnvironment[key] as ServerEnvironment;
      const showEnv = env !== currentEnv;
      showEnv &&
        buttons.push({
          text: `Switch to ${env.toUpperCase()}`,
          handler: () => this.switchServer(env),
        });
    }

    buttons.push({
      text: 'Cancel',
      role: 'cancel',
    });

    const actionSheet = this.actionSheetCtrl.create({ title, buttons });
    actionSheet.present();
  }

  private switchServer(env: ServerEnvironment) {
    this.loadingAlertCtrl.showLoader();
    this.userService
      .logout()
      .then(() => {
        this.loadingAlertCtrl.dismissLoader();
        return this.environment.switchServer(env);
      })
      .catch(() => {
        this.loadingAlertCtrl.dismissLoader();
        this.loadingAlertCtrl.showToastAlert('Error switching server');
      });
  }

  private logout() {
    this.loadingAlertCtrl.showLoader();
    this.userService
      .logout()
      .then(() => {
        this.loadingAlertCtrl.dismissLoader();
      })
      .catch(() => {
        this.loadingAlertCtrl.dismissLoader();
        this.loadingAlertCtrl.showToastAlert('Error switching server');
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/app-mode/app-mode.ts